module.exports = __webpack_public_path__ + "static/media/vesícula v1.6e8e2cbd.glb";